export default "__VITE_ASSET__55f38997__"